// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"45ac4014","191":"687f3ae5","311":"ba429839","376":"c802b16f","437":"619aeb35","995":"8aec5a3f"}[chunkId] + ".chunk.css";
};